import { GetListParams, GetListResult, RaRecord } from 'react-admin';
import IHandler from './IHandler';
import { postJson } from '../../../utils/api';

export default class UserTransactionsHandler implements IHandler {
  static prevNextToken: Record<number, string> = {};

  static async getListHandler<RecordType extends RaRecord = any>(
    _?: string,
    params?: GetListParams,
  ): Promise<GetListResult<RecordType>> {
    const userId = params?.meta?.userId ?? '';
    const query: { [key: string]: any } = {
      limit: params?.pagination.perPage ?? 100,
      ...params?.filter,
    };

    const page = params?.pagination.page ?? 1;
    if (page > 1 && UserTransactionsHandler.prevNextToken[page - 1] != null) {
      query.nextToken = UserTransactionsHandler.prevNextToken[page - 1];
    }

    for (const param in query) {
      if (
        query[param] === undefined ||
        query[param] === null ||
        query[param] === ''
      ) {
        delete query[param];
      }
    }

    return postJson(
      `/admin/user/${userId}/transaction`,
      query,
      process.env.REACT_APP_ADMIN_API_BASE_URL,
    ).then(async (response) => {
      const { data } = await response.json();
      const nextToken = data?.nextToken;
      UserTransactionsHandler.prevNextToken[page] = JSON.stringify(nextToken);

      return {
        data: data.transactions,
        pageInfo: {
          hasNextPage: !!nextToken,
          nextPageToken: nextToken ?? undefined,
        },
      };
    });
  }
}
